// extracted by mini-css-extract-plugin
export default {"CategoriesPage":"style_CategoriesPage__dgI2A"};